import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import type { VBaseInputProps } from '../VBaseInput';
import VInputTextareaWrapper from '../VInput/VInputTextareaWrapper';
import VInnerChipInput from './VInnerChipInput';
import type { VInnerChipInputProps } from './type';

const VChipInput = forwardRef(
  (
    {
      className,
      comment,
      disabled,
      fluid,
      id,
      label,
      required,
      style,
      valid,
      ...chipGroupProps
    }: VInnerChipInputProps & VBaseInputProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const baseInputProps = {
      className,
      comment,
      disabled,
      fluid,
      id,
      label,
      required,
      style,
      valid,
    };

    return (
      <VInputTextareaWrapper {...baseInputProps}>
        <VInnerChipInput ref={ref} {...chipGroupProps} />
      </VInputTextareaWrapper>
    );
  },
);

export default VChipInput;
